import request from '../../utils/request'
const urlParams = process.env.VUE_APP_UPLOAD_REAL_PATH
export default {
  // 获取小区列表
  villageList(data) {
    const params = data
    return request({
      url: urlParams + '/village/list',
      type: 'get',
      params: params
    })
  },  
  // 小区新增修改
  villageUpdata(data) {
    const params = data
    return request({
      url: urlParams + '/village/addOrUpd',
      type: 'post',
      params: params
    })
  },  
  // 小区列表-用户所管辖内全部小区
  villageListAll(data) {
    const params = data
    return request({
      url: urlParams + '/village/list-all',
      type: 'get',
      params: params
    })
  },   
  // 删除
  villageDel(data) {
    const params = data
    return request({
      url: urlParams + '/village/del',
      type: 'post',
      params: params
    })
  },   
}